import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useAdhesionDistributors = (term = null) => useQuery({ queryKey: [`adhesion-distributors`, term], queryFn: async () => {
    const callback = await API.get(`/adhesion/distributors?term=${term ?? ''}`)
    return callback?.data
}})

export default useAdhesionDistributors